import { AppButton, AppTextField } from 'components';
import { Fragment, useEffect, useState } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import StatusDropDown from 'components/molecules/StatusDropDown';
import Joi from 'joi';
import { checkForErrors } from 'utilities/fns';
import useManageStream from 'hooks/API/POST/useManagestream';
import useStream from 'hooks/API/GET/useStream';
import * as AppPics from 'assets/images';
import AppBreadcrumbs from 'components/molecules/AppBreadcrumbs';

function ManageStream() {
  const { streamID } = useParams();
  const history = useHistory();
  const [className, setClassName] = useState('');
  const [classKey, setClassKey] = useState('');
  const [status, setStatus] = useState('active');
  const [formErrors, setFormErrors] = useState([]);

  const handleGoBack = () => {
    history.goBack();
  };

  const { data: streamData, isLoading: isFetching } = useStream({
    enabled: !!streamID,
    streamID,
  });

  // Load preloaded data if editing
  useEffect(() => {
    const preloadedData = streamData?.data;
    if (preloadedData?._id) {
      setClassName(preloadedData?.name ?? '');
      setClassKey(preloadedData?.key ?? '');
      if (preloadedData?.status) setStatus(preloadedData.status);
    }
  }, [streamData]);

  // Form submission
  const manageStream = useManageStream();

  const handleStreamSubmit = () => {
    const data = { name: className, status };
    if (streamID) data.id = streamID;

    const validation = streamSchema.validate({ name: className, status }, { abortEarly: false });
    if (validation.error) {
      setFormErrors(validation.error.details);
      return;
    }
    manageStream.mutate(data);
  };

  const errors = checkForErrors(formErrors);

  if (isFetching) {
    return (
      <div className="mainWraper">
        <div className="container-fluid outerborder text-center p-5">Loading...</div>
      </div>
    );
  }

  return (
    <div className="mainWraper coursetabsection">
      <div className="tab">
        <ul className="tab__menu">
          <li className="back">
            <button className="btn-back" onClick={handleGoBack}>
              <img src={AppPics.BackSvg} alt="Back" />
            </button>
          </li>
        </ul>

        <div className="tab__content ___adjust___tab___padding">
          <div className="tab__content-actHead">
            <AppBreadcrumbs
              links={[
                { label: 'Dashboard', to: '/dashboard' },
                { label: 'Curriculum', to: '/curriculum' },
                { label: 'Streams', to: '/manage/stream' },
              ]}
              current={streamID ? 'Update Stream' : 'Add Stream'}
            />
          </div>

          <div className="tab__content-actBody">
            <div className="px-5 py-5">
              <div className="row">
                <div className="col-12">
                  <h2 className="prime-head p-0 boldtitle">
                    {streamID ? 'Update Stream' : 'Add Stream'}
                  </h2>
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <AppTextField
                    inputProps={{
                      value: className,
                      onChange: (e) => setClassName(e.target.value),
                      placeholder: 'Stream name *',
                    }}
                    labelProps={{ label: 'Name' }}
                    fieldErrors={errors['name']}
                  />
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <AppTextField
                    inputProps={{
                      value: classKey,
                      onChange: (e) => setClassKey(e.target.value),
                      placeholder: 'Stream key (leave blank for auto-generation)',
                    }}
                    labelProps={{ label: 'Key' }}
                    fieldErrors={errors['key']}
                    disabled={!!streamID} // Usually don't edit key
                  />
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <StatusDropDown
                    value={status}
                    handleChange={(e) => setStatus(e.target.value)}
                    fieldErrors={errors['status']}
                  />
                </div>
              </div>

              <div className="row mt-5">
                <div className="col-12 btnTab-foot d-flex justify-content-end">
                  <AppButton
                    variantClass="btn-primary mx-3"
                    onClick={handleStreamSubmit}
                    disabled={manageStream.isLoading}
                  >
                    {manageStream.isLoading ? 'Saving...' : 'Save Changes'}
                  </AppButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const streamSchema = Joi.object({
  name: Joi.string().required().min(2),
  status: Joi.string().required(),
});

export default ManageStream;
